import * as React from "react";

//Brands
import Panasonic from "../../../images/brands/Panasonic.jpg";
import Mitsubishi from "../../../images/brands/Mitsubishi.jpg";
import Haier from "../../../images/brands/Haier.jpg";
import Daikin from "../../../images/brands/Daikin.jpg";

//Slide
import DuctedVent from "../../../images/DuctedVent.jpg";
import SlideShow from "../../../components/slider";
import HeroBan from "../../../components/HeroBan";
import { useStaticQuery, graphql } from "gatsby";
import Layout from "../../../components/layout";

const DuctedPumps = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "residential/heat-pumps/ducted", idType: URI) {
          residentialHeatPumpDucted {
            ductedContent
            ductedImage {
              altText
              sourceUrl
            }
            ductedLink {
              target
              title
              url
            }
            heroBackgroundColor
            heroContent
            heroHeading
            heroImage {
              altText
              sourceUrl
            }
            heroLink {
              target
              title
              url
            }
            summaryContent
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.residentialHeatPumpDucted || {};

  return (
    <Layout pageContext={pageContext}>
      <HeroBan
        image={data?.heroImage?.sourceUrl}
        color={data?.heroBackgroundColor}
      >
        <h5>{data?.heroHeading}</h5>
        <p>{data?.heroContent}</p>
        <a href={data?.heroLink?.url} target={data?.heroLink?.target}>
          {data?.heroLink?.title}
        </a>
      </HeroBan>
      <div className="w-full bg-black ">
        <div className=" py-20 text-center text-white mx-auto w-11/12 max-w-6xl">
          <p className="text-2xl leading-8 font-bold">{data?.summaryContent}</p>
        </div>
      </div>
      <div className="lg:mx-auto md:mx-10 mx-5 max-w-7xl flex flex-wrap sm:justify-center">
        <img
          className="mb-14 mt-20 w-full"
          src={data?.ductedImage?.sourceUrl}
          alt={data?.ductedImage?.altText}
        ></img>
        <p
          className="text-2xl leading-8 max-w-6xl"
          dangerouslySetInnerHTML={{ __html: data?.ductedContent }}
        ></p>
        <a
          href={data?.ductedLink?.url}
          target={data?.ductedLink?.target}
          className="text-center w-full sm:w-auto bg-tan text-2xl text-black uppercase font-anton px-10 py-4 mt-24 mb-16"
        >
          {data?.ductedLink?.title}
        </a>
      </div>

      <div className="heat-pumps-logos flex flex-wrap items-center justify-center max-w-7xl my-28 mx-auto">
        <img className="px-2" src={Panasonic} alt="" />
        <img className="px-2" src={Mitsubishi} alt="" />
        <img className="px-2" src={Haier} alt="" />
        <img className="px-2" src={Daikin} alt="" />
      </div>
    </Layout>
  );
};

export default DuctedPumps;
